<div class="container-fluid px-0">
  <div class="row mt-4" style="position: absolute; width: 100%">
    <div class="col-6 col-md-4 col-lg-6">
      <a href="/">
        <img
          width="1"
          height="1"
          src="/assets/images/vtc.png"
          alt="logo-prinicpal"
          class="logo-principal"
        />
      </a>
      <h1 style="position: absolute; opacity: 0">Sobre Nosotros</h1>
    </div>
    <div class="d-none d-md-block col-md-8 col-lg-6 text-white text-right blur-background" style="text-align: right; padding-right: 20px; ">
      <span style="text-align: right; color: white; text-decoration: none;">
      <a href="/home" style="color: white; text-decoration: none;">
        Inicio
        <span style="margin-left: 15px;">|</span>
      </a>
      @if( baseUrl.includes('ec.visatravelcenter') || baseUrl.includes('//visatravelcenter.com')){
        <a href="https://ec.visatravelcenter.com/asesoria-migratoria" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Según tu Destino
          <span style="margin-left: 15px;">|</span>
        </a>
        <a href="https://ec.visatravelcenter.com/asesoria-migratoria-estudios-exterior" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Para Estudios
          <span style="margin-left: 15px;">|</span>
        </a>
      }
      @if( baseUrl.includes('co.visatravelcenter') ){
        <a href="https://co.visatravelcenter.com/asesoria-migratoria" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Según tu Destino
          <span style="margin-left: 15px;">|</span>
        </a>
        <a href="https://co.visatravelcenter.com/asesoria-migratoria-estudios-exterior" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Para Estudios
          <span style="margin-left: 15px;">|</span>
        </a>
      }

      @if( baseUrl.includes('go.visatravelcenter') || baseUrl.includes('localhost')){
        <a href="https://go.visatravelcenter.com/asesoria-migratoria" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Según tu Destino
          <span style="margin-left: 15px;">|</span>
        </a>
        <a href="https://go.visatravelcenter.com/asesoria-migratoria-estudios-exterior" style="color: white; text-decoration: none; margin-left: 15px">
          Asesoría Para Estudios
          <span style="margin-left: 15px;">|</span>
        </a>
      }
      <a href="/blog" style="color: white; text-decoration: none; margin-left: 15px">
        Blog
        <span style="margin-left: 15px;">|</span>
      </a>

      @if( baseUrl.includes('ec.visatravelcenter') || baseUrl.includes('go.visatravelcenter') || baseUrl.includes('//visatravelcenter.com') || baseUrl.includes('localhost')){
        <a href="https://api.whatsapp.com/send?phone=593961459059&text=Quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20asesorias%20migratorias!" target="_blank" class="footer-link" style="color: white; text-decoration: none;">
          <img
          width="1"
          height="1"
          src="/assets/images/whatsapp.png"
          alt="whatsappnicpal"
          style="width:16px; height: auto; margin-left: 30px; display: inline-block;"
        />
          +593961459059
          <img
            width="1"
            height="1"
            src="/assets/images/ecuador.png"
            alt="banner-prinicpal"
            style="width:16px; height: auto; margin-top: -5px; margin-right: 10px"
          />
        </a>
      }
      @if( baseUrl.includes('co.visatravelcenter')){
        <a href="https://api.whatsapp.com/send?phone=573202176827&text=Quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20asesorias%20migratorias!" target="_blank" class="footer-link">
          <img
            width="1"
            height="1"
            src="/assets/images/whatsapp.png"
            alt="whatsappnicpal"
            style="width:16px; height: auto; margin-left: 30px; display: inline-block;"
          />
          +573202176827
          <img
          width="1"
          height="1"
          src="/assets/images/colombia.png"
          alt="whatsappnicpal"
          style="width:16px; height: auto; margin-top: -5px"
        /></a>
      }</span>
    </div>
    @if( baseUrl.includes('ec.visatravelcenter') || baseUrl.includes('go.visatravelcenter') || baseUrl.includes('//visatravelcenter.com') || baseUrl.includes('localhost')){
      <div class="col-6 d-block d-md-none text-right">
        <a target="_blank" href="https://api.whatsapp.com/send?phone=593961459059&amp;text=Buen%20d%C3%ADa,%20quisiera%20tener%20asesor%C3%ADa%20personalizada%20para%20mi%20Asesoria%20Migratoria">
          <img
            width="1"
            height="1"
            src="/assets/images/ws-mobile.png"
            alt="contacto whatsapp"
            style="height: 30px; width: auto; margin-top: 5px;"
            class=""
          />
        </a>
      </div>
    }
    @if( baseUrl.includes('co.visatravelcenter')){
      <div class="col-6 d-block d-md-none text-right">

        <a target="_blank" href="https://api.whatsapp.com/send?phone=573202176827&amp;text=Buen%20d%C3%ADa,%20quisiera%20tener%20asesor%C3%ADa%20personalizada%20para%20mi%20Asesoria%20Migratoria">
          <img
            width="1"
            height="1"
            src="/assets/images/ws-mobile.png"
            alt="contacto whatsapp"
            style="height: 30px; width: auto; margin-top: 5px;"
            class=""
          />
        </a>
      </div>
    }
  </div>
  <img
    width="1"
    height="1"
    src="/assets/images/about-fondo.webp"
    alt="banner-prinicpal"
    style="width: 100%; height: auto;"
    class="d-none d-md-block"
  />
  <img
    width="1"
    height="1"
    src="/assets/images/about-fondo-mobile.png"
    alt="banner-prinicpal"
    style="width: 100%; height: auto;"
    class="d-block d-md-none"
  />
</div>

<div class="container">
  <div class="row px-3 px-md-5">
    <div class="about-us-box mt-5 mb-5 px-md-5">
      <p class="about-us">
        <span style="font-weight: 600;">¿Alguna vez has sentido que tu meta está tan cerca y tan lejos a la vez?</span> Ese es el sentimiento que muchos experimentan al planear un viaje al extranjero. <span style="font-weight: 600;">En Visa Travel Center</span>, no solo entendemos esa sensación; <span style="font-weight: 600;">la vivimos contigo</span>. <br><br>
        Podríamos llenarte de números impresionantes, como nuestro <span style="font-weight: 600;">90% de éxito en trámites de visas</span>, o hablarte de nuestra experiencia de <span style="font-weight: 600;">más de 16 años en el mercado</span>. Pero ¿sabes qué? Preferimos contarte sobre el viaje que podemos emprender juntos.<br><br>
        <span style="font-weight: 600;">Tu autorrealización es nuestra prioridad</span>. Nos apasiona ser el <span style="font-weight: 600;">impulso en tu plan de vida</span>, porque creemos que nada debería frenar tus metas, mucho menos las fronteras.<br><br>
        Imagina tener un grupo de amigos expertos que:<br>
        · Entienden tu propósito de viaje<br>
        · Te asesoran con empatía y compromiso<br>
        · Te acompañan desde la planificación hasta tu regreso a casa<br><br>
        Eso somos en  <span style="font-weight: 600;">Visa Travel Center</span>. No solo tramitamos tu visa; volamos contigo en espíritu, te protegemos al llegar a tu destino y te apoyamos cuando decides volver.<br><br>
        <span style="font-weight: 600;">¿Cómo lo hacemos?</span>
        Siendo empáticos, apasionados y comprometidos
        Ofreciendo soluciones personalizadas a tus necesidades
        Utilizando tecnología de punta para agilizar procesos
        Generando experiencias positivas de principio a fin <br><br>
        No solo somos expertos en migración; <span style="font-weight: 600;">somos tu equipo de apoyo</span>, tu fuente de tranquilidad y tu puente hacia nuevas oportunidades. Porque entendemos que un viaje no se trata solo de llegar a un destino, <span style="font-weight: 600;">sino de transformar tu vida en el proceso</span>.<br><br>
        Recuerda: con <span style="font-weight: 600;">Visa Travel Center</span>, tus metas no conocen fronteras.

      </p>
    </div>
  </div>
</div>

<footer class="container-fluid footer-bg footer pb-4">
  <div class="container d-none d-lg-block">
    <div class="row pt-5">
      <div class="col">
        <p class="text-white footer-title">Nuestros locales</p>
        <p class="footer-title mt-4" style="font-size: 13px;">Ecuador</p>
        <a href="https://maps.app.goo.gl/RE5sV2ZULEf1W6ZX8" target="_blank"  class="mt-2" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Bosques del Salado y Rodrigo Chávez G, <span style="font-weight:  bold;">Guayaquil.</span></a><br>
        <a href="https://maps.app.goo.gl/RwHX8cRz31h8cmeW8" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">La Pinta y Amazonas. Edificio Libertad, <span style="font-weight:  bold;">Quito.</span></a><br>
        <a href="https://maps.app.goo.gl/QA3mrf6WD76MdxaS6" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Presidente Córdova y Benigno Malo, <span style="font-weight:  bold;">Cuenca.</span></a><br>

        <p class="footer-title mt-4" style="font-size: 13px;">Colombia</p>
        <a href="https://maps.app.goo.gl/zNKaKv8NDGap8biU8" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Edificio Manhattan center, Oficina: 201#15-17, Chapinero, <span style="font-weight:  bold;">Bogotá.</span></a><br>
      </div>
      <div class="col">
        <p class="footer-title">Ventas</p>
        <p style="margin-bottom: 0px;">
          <a href="https://api.whatsapp.com/send?phone=593961459059&text=Quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20asesorias%20migratorias!" target="_blank" class="footer-link">
            <img
              width="18"
              height="20"
              class="ws-footer"
              src="/assets/images/whatsapp.png"
              alt="visatravelcenter whatsapp"
              style="margin-right: 2px; margin-bottom: 2px"
            />
            <span class="text-white" style="font-weight: 600; font-size: 18px">+593961459059</span>
            <img
            width="15"
            height="15"
            class="ws-footer"
            src="/assets/images/ecuador.png"
            alt="visatravelcenter whatsapp colombia"
            style="margin-left: 5px; margin-bottom: 5px"
        /></a>
        </p>
        <p style="margin-top: 5px;">
          <a href="https://api.whatsapp.com/send?phone=573202176827&text=Quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20asesorias%20migratorias!" target="_blank" class="footer-link">
            <img
              width="18"
              height="20"
              class="ws-footer"
              src="/assets/images/whatsapp.png"
              alt="visatravelcenter whatsapp"
              style="margin-right: 2px; margin-bottom: 2px"
            />
            <span class="text-white" style="font-weight: 600; font-size: 18px">+573202176827</span>
            <img
            width="15"
            height="15"
            class="ws-footer"
            src="/assets/images/colombia.png"
            alt="visatravelcenter whatsapp colombia"
            style="margin-left: 5px; margin-bottom: 5px"
          /></a>
        </p>
        <p class="mt-3" style="font-weight: 300; font-size: 13px; color: white; line-height: 1.2; padding-right: 20px">De lunes a viernes de 8 a 17 hs
          Sábados de 9 a 13 hs</p>
      </div>
      <div class="col">
        <p class="footer-title">Productos</p>
        <p class="products-list">
          <a href="/home" style="color: white; text-decoration: none">Visas</a>
        </p>
        <p class="products-list">
          <a href="/home" style="color: white; text-decoration: none">Seguros de viajes</a>
          <span></span>
        </p>
        <p class="products-list">
          <a href="/home"style="color: white; text-decoration: none">Paquetes</a>
        </p>
        <a href="/blog" style="text-decoration: none;">
          <p class="text-white footer-title"><span class="font-size-15 bolder-d gris-claro">Blog</span><br /></p>
        </a>
        <a href="/home" style="text-decoration: none;">
          <p class="text-white footer-title"><span class="font-size-15 bolder-d gris-claro">Inicio</span><br /></p>
        </a>
      </div>
      <div class="col">
        <p class="footer-title">Legales</p>
        <p class="text-white" style="font-weight: 400; font-size: 14px">
          Cumplimos con los permisos exigidos. ÓRBITA GROUP NÚMERO LUAE: 474452. NÚMERO DE TRÁMITE: 2023WEBLUAE30731. MARCA OPERADA POR: ÓRBITA GROUP- SEVIFRAL S.A.
        </p>
        <a href="/politicas-privacidad" style="text-decoration: none;">
          <p class="text-white"><span class="font-size-15 bolder-d gris-claro">Políticas de privacidad</span><br /></p>
        </a>
      </div>
      <div class="col">
        <div>
          <span style="color: white; font-size: 14px; font-weight: bold">Síguenos en</span>
            <div class="mt-3">
              <span class="mt-4">
                <a target="_blank" href="https://www.facebook.com/visatravelcenter/">
                  <img
                    width="30"
                    height="30"
                    class="red-social"
                    src="/assets/images/social-fb.png"
                    alt="visatravelcenter facebook"
                    style="margin-right: 10px;"
                  />
                </a>
                <a target="_blank" href="https://www.instagram.com/visatravelcenter/">
                  <img
                    width="30"
                    height="30"
                    class="red-social"
                    src="/assets/images/social-ig.png"
                    alt="visatravelcenter Instagram"
                    style="margin-right: 10px;"
                  />
                </a>
                <a target="_blank" href="https://www.tiktok.com/@visatravelcenter/">
                  <img
                    width="30"
                    height="30"
                    class="red-social"
                    src="/assets/images/social-tk.png"
                    alt="visatravelcenter tiktok"
                    style="margin-right: 10px;"
                  />
                </a> </span>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-lg-none pb-5">
    <div class="col-12 mt-3 text-center">
      <p class="text-white footer-title">Nuestros locales</p>
      <p class="footer-title mt-4" style="font-size: 13px;">Ecuador</p>
      <a href="https://maps.app.goo.gl/RE5sV2ZULEf1W6ZX8" target="_blank"  class="mt-2" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Bosques del Salado y Rodrigo Chávez G, <span style="font-weight:  bold;">Guayaquil.</span></a><br>
      <a href="https://maps.app.goo.gl/RwHX8cRz31h8cmeW8" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">La Pinta y Amazonas. Edificio Libertad, <span style="font-weight:  bold;">Quito.</span></a><br>
      <a href="https://maps.app.goo.gl/QA3mrf6WD76MdxaS6" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Presidente Córdova y Benigno Malo, <span style="font-weight:  bold;">Cuenca.</span></a><br>

      <p class="footer-title mt-4" style="font-size: 13px;">Colombia</p>
      <a href="https://maps.app.goo.gl/zNKaKv8NDGap8biU8" target="_blank" style="font-weight: 300; font-size: 13px; color: white; text-decoration: none">Edificio Manhattan center, Oficina: 201#15-17, Chapinero, <span style="font-weight:  bold;">Bogotá.</span></a><br>
    </div>
    <div class="col-12 text-center mt-4">
      <p class="footer-title">Ventas</p>
    <p style="margin-bottom: 0px;">
      <img
        width="18"
        height="20"
        class="ws-footer"
        src="/assets/images/whatsapp.png"
        alt="visatravelcenter whatsapp"
        style="margin-right: 2px; margin-bottom: 2px"
      />
      <span class="text-white" style="font-weight: 600; font-size: 18px">+593961459059</span>
      <img
      width="15"
      height="15"
      class="ws-footer"
      src="/assets/images/ecuador.png"
      alt="visatravelcenter whatsapp colombia"
      style="margin-left: 5px; margin-bottom: 5px"
    />
    </p>
    <p style="margin-top: 5px;">
      <img
        width="18"
        height="20"
        class="ws-footer"
        src="/assets/images/whatsapp.png"
        alt="visatravelcenter whatsapp"
        style="margin-right: 2px; margin-bottom: 2px"
      />
      <span class="text-white" style="font-weight: 600; font-size: 18px">+573202176827</span>
      <img
      width="15"
      height="15"
      class="ws-footer"
      src="/assets/images/colombia.png"
      alt="visatravelcenter whatsapp colombia"
      style="margin-left: 5px; margin-bottom: 5px"
    />
    </p>
    <p class="mt-3" style="font-weight: 300; font-size: 13px; color: white; line-height: 1.2; padding-right: 20px">De lunes a viernes de 8 a 17 hs
      Sábados de 9 a 13 hs</p>
  </div>
  <div class="col-12 text-center">
    <span style="color: white; font-size: 14px; font-weight: bold">Síguenos en</span>
      <span class="mt-4">
        <a target="_blank" href="https://www.facebook.com/visatravelcenter/">
          <img
            width="30"
            height="30"
            class="red-social"
            src="/assets/images/social-fb.png"
            alt="visatravelcenter facebook"
            style="margin-right: 10px;"
          />
        </a>
        <a target="_blank" href="https://www.instagram.com/visatravelcenter/">
          <img
            width="30"
            height="30"
            class="red-social"
            src="/assets/images/social-ig.png"
            alt="visatravelcenter Instagram"
            style="margin-right: 10px;"
          />
        </a>
        <a target="_blank" href="https://www.tiktok.com/@visatravelcenter/">
          <img
            width="30"
            height="30"
            class="red-social"
            src="/assets/images/social-tk.png"
            alt="visatravelcenter tiktok"
            style="margin-right: 10px;"
          />
        </a> </span>
  </div>
  </div>
</footer>

<div class="container-fluid d-none d-lg-block" style="background-color: #183755">
  <div class="row">
    <div class="col-12 text-white text-center" style="padding-top: 20px; padding-bottom: 20px; font-weight: 300">
        <img
          width="180"
          height="40"
          class="red-social"
          src="assets/images/vtc.png"
          alt="logo vtc"
          style="margin-right: 20px; width: 180px !important; height: auto"
      />
      2024 All Rights Reservered. Asistencia Médica con Cobertura Mundial.
    </div>
  </div>
</div>

<div class="container-fluid d-lg-none" style="background-color: #183755">
  <div class="row">
    <div class="col-12 text-white text-center d-none d-lg-block" style="padding-top: 20px; padding-bottom: 20px">
        <img
          width="180"
          height="40"
          class="red-social"
          src="assets/images/vtc.png"
          alt="logo vtc"
          style="margin-right: 20px;"
      />
    </div>
    <div class="col-12 text-white text-center d-block d-lg-none" style="padding-top: 20px; padding-bottom: 20px">
      <img
        width="180"
        height="40"
        class="red-social"
        src="assets/images/vtc.png"
        alt="logo vtc"
        style="margin-right: 20px; height: auto; width: 200px !important"
    />
  </div>
  </div>
  <div class="row">
    <div class="col-12 text-white text-center" style="padding-bottom: 20px; font-weight: 400">
      <span style="font-weight: 300">2024 All Rights Reservered. Asistencia Médica con Cobertura Mundial.</span>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" >
    <div class="modal-content" style="border-radius: 24px; padding: 5px 16px">
      <div class="modal-header" style="border-bottom: none;">
        <h3 class="modal-title" id="staticBackdropLabel" style="font-size: 30px; font-family: 'Yeseva One', serif; margin-top: 7px">{{ selectedVisa.name }}</h3>
        <a data-bs-dismiss="modal" aria-label="Close" style="background-color: none; text-decoration: none; cursor: pointer;">x Cerrar</a>
      </div>
      <div class="modal-body">
        {{ selectedVisa.description }}
        @if(currentTab == "visa"){
          <p class="mt-4" style="font-family: 'Yeseva One', serif; font-weight: 500; font-size:19px">Completa tus datos y recibe tu asesoría</p>
        }
        @if(currentTab == "paquetes"){
          <p class="mt-4" style="font-family: 'Yeseva One', serif; font-weight: 500; font-size:19px">Completa tus datos y reserva tu viaje. Este incluye:</p>
          <div>
            <ul>
              @for (benefit of selectedVisa.benefits; track benefit) {
                <li>{{benefit}}</li>
              }
            </ul>
          </div>
        }
        @if(currentTab == "seguros"){
          <p class="mt-4" style="font-family: 'Yeseva One', serif; font-weight: 500; font-size:19px">Viaja protegido. Completa tus datos ahora y cotiza tu plan. Este incluye:</p>
          <div>
            <ul>
              @for (benefit of selectedVisa.benefits; track benefit) {
                <li>{{benefit}}</li>
              }
            </ul>
          </div>
        }
        <div class="row">
          <div class="col-6">
            <img src="/assets/images/form-name.png"alt="Nombre Completo" style="width: auto; height: 38px; position:absolute; margin-top: 10px">
            <input type="text" class="form-control" placeholder="Nombre Completo" style="border-radius: 20px; margin-top: 10px; border: 1px solid rgba(19, 107, 192, 0.4); padding-left: 46px">
          </div>
          <div class="col-6">
            <img src="/assets/images/form-phone.png"alt="telefono" style="width: auto; height: 38px; position:absolute; margin-top: 10px">
            <input type="text" class="form-control" placeholder="Teléfono (Whatsapp)" style="border-radius: 20px; margin-top: 10px; border: 1px solid rgba(19, 107, 192, 0.4); padding-left: 46px">
          </div>
          <div class="col-6">
            <img src="/assets/images/form-people.png" alt="E-mail" style="width: auto; height: 38px; position:absolute; margin-top: 10px">
            <select class="form-control" style="border-radius: 20px; margin-top: 10px; border: 1px solid rgba(19, 107, 192, 0.4); padding-left: 46px">
              <option value="" disabled selected>¿Viajas sólo o en grupo?</option>
              @for (passenger of passengers; track passenger) {
                <option [value]="passenger">Pasajeros: {{ passenger }}</option>
              }

            </select>
          </div>
          <div class="col-6">
            <img src="/assets/images/form-email.png"alt="E-mail" style="width: auto; height: 38px; position:absolute; margin-top: 10px">
            <input type="text" class="form-control" placeholder="E-mail" style="border-radius: 20px; margin-top: 10px; border: 1px solid rgba(19, 107, 192, 0.4); padding-left: 46px">
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            @if(currentTab == "visa"){
              <button class="btn btn-primary mt-4" style="border-radius: 20px; padding: 10px 20px; background-color: #5BA332; border: none">Quiero mi Asesoría</button>
            }
            @if(currentTab == "paquetes"){
              <button class="btn btn-primary mt-4" style="border-radius: 20px; padding: 10px 20px; background-color: #5BA332; border: none">Quiero mi Paquete</button>
            }
            @if(currentTab == "seguros"){
              <button class="btn btn-primary mt-4" style="border-radius: 20px; padding: 10px 20px; background-color: #5BA332; border: none">Quiero mi Seguro de Viaje</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
